export default __webpack_public_path__ + "static/media/whiteBackground4k.83eb2b87.png";